import React, { Component } from 'react';
import {connect} from 'react-redux';
import {createVideo, showModalFlag, showDetailFlag} from '../../actions';

import List from '../../components/list';
import {Video, Detail} from '../../components/modal';
import {SearchErr} from '../../components/errorpage';

class SearchContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      showModal: false,
      modalInfo: {}
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.hadnleOnDetailClick = this.hadnleOnDetailClick.bind(this);
    this.handleDetailClose = this.handleDetailClose.bind(this);
  }

  async handleOnClick(item){
    await this.setState({
      showModal: true,
      modalInfo: item
    });
    await this.props.showModalFlag(this.state.showModal);
  }

  async hadnleOnDetailClick(detailInfo){
    await this.setState({
      showDetail: true,
    });
    await this.props.showDetailFlag(this.state.showDetail, detailInfo);
  }


  handleContextMenuClick(options){
    const {data} = options;

    // selector
    const videoNum = options.data.toLowerCase();
    const videoObj = {};
    videoObj[videoNum] = options;
    this.props.createVideo(videoObj);
  }
  async handleModalClose () {
    await this.setState({showModal: false});
    await this.props.showModalFlag(this.state.showModal);
  }

  async handleDetailClose(){
    await this.setState({showDetail: false});
    await this.props.showDetailFlag(this.state.showDetail);
  }


  render() {
    const {list, activePage} = this.props;
    const {
      showModal,
      modalInfo,
      showDetail
    } = this.state;
    const VideoModal = showModal ? <Video  handleModalClose={this.handleModalClose} modalInfo={modalInfo}/> : null;
    const DetailModal = showDetail && <Detail handleDetailClose={this.handleDetailClose}/>;
    return (
      <ul className='list-container'>
        {list.length > 0 ? (list.map((item, index) => 
          <List item={item} key={`item_${item.num}`}
                activePage={activePage}
                index={index}
                onDetailClick = {this.hadnleOnDetailClick}
                onClick={this.handleOnClick}
                onContextMenuClick={this.handleContextMenuClick}/>
        )) : <SearchErr />}
        {VideoModal}
        {DetailModal}
      </ul>
    );
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    createVideo: (videoItem) => dispatch(createVideo(videoItem)),
    showModalFlag: (modalFlag) => dispatch(showModalFlag(modalFlag)),
    showDetailFlag: (detailFlag, detailInfo) => dispatch(showDetailFlag(detailFlag, detailInfo))
  }
};

SearchContainer = connect(undefined,mapDispatcherToProps)(SearchContainer);

export default SearchContainer;


// WEBPACK FOOTER //
// ./src/containers/search/SearchContainer.js